import { Component, Input, OnInit } from "@angular/core";
import { ListingGridService } from "../../../services/listing-grid.service";
import { ActivatedRoute, Router } from "@angular/router";
import { DomSanitizer } from "@angular/platform-browser";
import { MatCardModule } from "@angular/material/card";
import { MatDividerModule } from "@angular/material/divider";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MaterialsService } from "src/app/services/materials.service";
import { AppSettingService } from "src/app/services/app-setting.service";
import { api } from "src/app/properties/endpoints";

type MarketplaceKey = 'amazon' | 'flipkart' | 'myntra' | 'ajio' | 'meesho';

interface MarketplaceLink {
  key: MarketplaceKey;
  label: string;
  icon: string;
  url: string;
  enabled: boolean;
}

@Component({
  selector: "app-product-card-molecule",
  templateUrl: "./product-card-molecule.component.html",
  styleUrls: ["./product-card-molecule.component.scss"],
})
export class ProductCardMoleculeComponent implements OnInit {
  @Input() item: any;
  @Input() detailedView: boolean = false;
  @Input() disableRoute: boolean = false;
  @Input() showAdditionalInfo: boolean = false;
  routeList;

  rosTrendIcon: String;
  rosTrendIconColor: String;
  latestDateSold: String;
  rosDifference: Number;
  broken: boolean;
  price: String;
  discount: String;
  blockStatus: { productionBlock: boolean, planningBlock: boolean }
  blockAttributes: string[] = ['productionBlock', 'planningBlock'];
  waitForBlockStatus: boolean;
  lifecycleStatus;
  lifeCycleOptions: string[] = [];
  showAnalytics: boolean = false;
  @Input() customClass : string = ''
  host:string;
  marketplaceUrls: { [key: string]: string } = {};
  readonly marketplaces: { key: MarketplaceKey, label: string, icon: string }[] = [
    { key: 'amazon', label: 'Amazon', icon: 'assets/img/marketplaces/amazon.png' },
    { key: 'flipkart', label: 'Flipkart', icon: 'assets/img/marketplaces/flipkart.png' },
    { key: 'myntra', label: 'Myntra', icon: 'assets/img/marketplaces/myntra.png' },
    { key: 'ajio', label: 'Ajio', icon: 'assets/img/marketplaces/ajio.png' },
    { key: 'meesho', label: 'Meesho', icon: 'assets/img/marketplaces/meesho.png' }
  ];
  orderedMarketplaces: MarketplaceLink[] = [];
  constructor(
    private listinggridservice: ListingGridService,
    private route: ActivatedRoute,
    private router: Router,
    private sanitizer: DomSanitizer,
    private matCardModule: MatCardModule,
    private matDividerModule: MatDividerModule,
    private snack: MatSnackBar,
    private lifeCycleStatus: MaterialsService,
    private settingService: AppSettingService
  ) { }

  ngOnInit(): void {
    this.host = new URL(api.host).hostname.split(".")[0];
    const forecastSetting = this.getForecastSetting();
    this.showAnalytics = forecastSetting ? true : false;
    this.routeList = this.detailedView ? null : ['/product/listing', { code: this.item.product }];
    this.updateOrderedMarketplaces();
    if (this.detailedView) {
      this.loadMarketplaceAttributes();
      this.listinggridservice.getBlockByProductCode(this.item.code).subscribe(res => {
        this.blockStatus = { planningBlock: res['planningBlock'], productionBlock: res['productionBlock'] }
        if (res['lifeCycleStatus'] === "" || null == res['lifeCycleStatus']) {
          this.lifecycleStatus = "none";
        }
        else {
          this.lifecycleStatus = res['lifeCycleStatus'];
        }
      }, (error) => { }, () => {
        this.waitForBlockStatus = true;
      });

      this.lifeCycleStatus.getMaterialForm().subscribe(res => {
        const lifeCycleStatusObj = res['metaData'].filter(item => item.identifier === 'lifeCycleStatus');
        this.lifeCycleOptions = lifeCycleStatusObj[0].values;
      })
    }
    if (
      this.item.max_sell_price &&
      this.item.min_sell_price &&
      this.item.max_sell_price != this.item.min_sell_price
    ) {
      this.price = `₹${this.item.min_sell_price} - ₹${this.item.max_sell_price}`;
    } else if (this.item.max_sell_price || this.item.min_sell_price) {
      this.price = `₹${this.item.min_sell_price | this.item.max_sell_price}`;
    } else {
      this.price = "-";
    }
    if (
      this.item.max_discount_percent &&
      this.item.min_discount_percent &&
      this.item.max_discount_percent != this.item.min_discount_percent
    ) {
      this.discount = `${this.item.min_discount_percent} - ${this.item.max_discount_percent}%`;
    } else if (
      this.item.max_discount_percent ||
      this.item.min_discount_percent
    ) {
      this.discount = `${this.item.min_discount_percent | this.item.max_discount_percent
        }%`;
    } else {
      this.discount = "-";
    }
    if ((this.detailedView ? this.item.latestDateSold : this.item.latest_date_sold) != null) {
      const latestSold = this.detailedView ? this.item.latestDateSold : this.item.latest_date_sold;
      const differenceInDays = Math.floor(
        (new Date().getTime() - new Date(latestSold).getTime()) /
        (1000 * 60 * 60 * 24)
      );
      if (differenceInDays === 1) {
        this.latestDateSold = "Sold yesterday";
      } else {
        this.latestDateSold = `Sold ${differenceInDays} days ago`;
      }
    }
    if (this.item.broken_channel_count && this.item.broken_channel_count > 0) {
    }
    if (
      (this.detailedView ? this.item.shortTermRateOfSale : this.item.shortterm_ros) != null &&
      (this.detailedView ? this.item.mediumTermRateOfSale : this.item.mediumterm_ros) != null
    ) {
      const shortTerm = this.detailedView ? this.item.shortTermRateOfSale : this.item.shortterm_ros;
      const mediumTerm = this.detailedView ? this.item.mediumTermRateOfSale : this.item.mediumterm_ros;
     const differenceInRos = shortTerm - mediumTerm;
      this.rosDifference = Math.floor(
        (differenceInRos / mediumTerm) * 100
      );
      if (differenceInRos <= 1 && differenceInRos >= -1) {
        this.rosTrendIcon = "trending_flat";
        this.rosTrendIconColor = "orange";
      } else if (differenceInRos > 1) {
        this.rosTrendIcon = "trending_up";
        this.rosTrendIconColor = "green";
      } else {
        this.rosTrendIcon = "trending_down";
        this.rosTrendIconColor = "darkred";
      }
    }
  }
  getForecastSetting(): string {
    const settings = this.settingService?.getSettings();
    return settings?.analytics || false;
  }

  isMarketplaceUrlValid(url: string): boolean {
    if (!url) {
      return false;
    }

    try {
      const parsedUrl = new URL(url);
      return parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:';
    } catch {
      return false;
    }
  }

  getMarketplaceUrl(marketplace: MarketplaceKey): string {
    return this.marketplaceUrls[marketplace]
      || this.item?.[`${marketplace}_url`]
      || this.item?.[`${marketplace}Url`]
      || null;
  }

  private updateOrderedMarketplaces(): void {
    this.orderedMarketplaces = this.marketplaces
      .map((marketplace) => ({
        ...marketplace,
        url: this.getMarketplaceUrl(marketplace.key),
        enabled: this.isMarketplaceUrlValid(this.getMarketplaceUrl(marketplace.key))
      }));
  }

  trackMarketplace(index: number, marketplace: MarketplaceLink): MarketplaceKey {
    return marketplace.key;
  }

  private loadMarketplaceAttributes(): void {
    const materialCode = this.getMarketplaceMaterialCode();
    if (!materialCode) {
      return;
    }

    this.lifeCycleStatus.getMaterialAttributes(materialCode).subscribe((response: any) => {
      const attributes = response?.attributes || response?.dynamicAttrs || [];
      attributes.forEach((attribute: any) => {
        const marketplace = this.getMarketplaceFromAttribute(attribute?.attributeName);
        if (marketplace && attribute?.attributeValue) {
          this.marketplaceUrls[marketplace] = attribute.attributeValue;
        }
      });
      this.updateOrderedMarketplaces();
    }, () => {
      this.marketplaceUrls = {};
      this.updateOrderedMarketplaces();
    });
  }

  private getMarketplaceMaterialCode(): string {
    const explicitCode = this.item?.materialCode
      || this.item?.sku
      || this.item?.skuCode
      || this.item?.variantCode;

    if (explicitCode) {
      return explicitCode;
    }

    const productCode = this.item?.code;
    return productCode && !productCode.endsWith('-S') ? `${productCode}-S` : productCode;
  }

  private getMarketplaceFromAttribute(attributeName: string): MarketplaceKey | null {
    const normalizedName = attributeName?.replace(/[_-]/g, '').toLowerCase();
    if (normalizedName === 'amazonurl') {
      return 'amazon';
    }
    if (normalizedName === 'flipkarturl') {
      return 'flipkart';
    }
    if (normalizedName === 'myntraurl') {
      return 'myntra';
    }
    if (normalizedName === 'ajiourl') {
      return 'ajio';
    }
    if (normalizedName === 'meeshourl') {
      return 'meesho';
    }
    return null;
  }

  openMarketplace(event: MouseEvent, url: string): void {
    event.preventDefault();
    event.stopPropagation();

    if (!this.isMarketplaceUrlValid(url)) {
      return;
    }

    window.open(url, '_blank', 'noopener,noreferrer');
  }

  handleLifeCycleChange(event) {
    (this.lifecycleStatus !== 'none') && this.listinggridservice.updateMaterialAttribute(this.item.code, 'lifeCycleStatus', this.lifecycleStatus, true).subscribe(res => {
      const msg = `${res}`;
      this.snack.open(msg, "close", {
        duration: 4000,
        horizontalPosition: "center",
        verticalPosition: "top",
      });
    }, (error => {
      const msg = `${error}`;
      this.snack.open(msg, "close", {
        duration: 4000,
        horizontalPosition: "center",
        verticalPosition: "top",
      });
    }))
  }

  onChangeBlockStatus(attribute) {
    this.listinggridservice.updateMaterialAttribute(this.item.code, attribute, this.blockStatus[attribute], true).subscribe(res => {
      const msg = `${res}`;
      this.snack.open(msg, "close", {
        duration: 4000,
        horizontalPosition: "center",
        verticalPosition: "top",
      });
    }, (error => {
      const msg = `${error}`;
      this.snack.open(msg, "close", {
        duration: 4000,
        horizontalPosition: "center",
        verticalPosition: "top",
      });
    }))
  }
}
